import { type ProcedureStepFields, type Stored } from "@overmap-ai/common"
import { selectAttachmentsOfProcedureStepFields } from "@overmap-ai/core"
import { FieldsRenderer } from "@overmap-ai/forms"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

import { sdk } from "../../sdk"
import { useShallowEqaulSelector } from "../../store"
import { draftCancelButtonProps, submitButtonProps } from "./constants"
import { useDeserializeFieldSchemaConfig, useFieldSchemaFromConfig, useHydrateFieldsWithAttachments } from "./hooks"

interface ProcedureStepFieldsSubmitterProps extends Omit<
	ComponentProps<typeof FieldsRenderer>,
	"fieldSchema" | "cancelButtonProps" | "submitButtonProps"
> {
	procedureStepFields: Stored<ProcedureStepFields>
}

export const ProcedureStepFieldsSubmitter = memo<ProcedureStepFieldsSubmitterProps>((props) => {
	const { className, procedureStepFields, ...rest } = props

	const attachments = useShallowEqaulSelector(selectAttachmentsOfProcedureStepFields(procedureStepFields.uuid))

	const fieldSchemaConfig = useDeserializeFieldSchemaConfig(procedureStepFields.fields)

	const fieldsSchemaConfigWithImages = useHydrateFieldsWithAttachments(
		fieldSchemaConfig,
		attachments,
		sdk.procedureStepFieldsAttachments,
	)
	const fieldSchema = useFieldSchemaFromConfig(fieldsSchemaConfigWithImages)

	return (
		<FieldsRenderer
			className={cx(className, "h-max w-full")}
			fieldSchema={fieldSchema}
			submitButtonProps={submitButtonProps}
			cancelButtonProps={draftCancelButtonProps}
			{...rest}
		/>
	)
})
ProcedureStepFieldsSubmitter.displayName = "ProcedureStepFieldsSubmitter"
